import useTrait from './use.trait';
import { allow } from '../classes/allow';
import is from '../objects/is';

export const useInflightTracker = () => {
    const inflightCalls = useTrait([]);
   
    const addApiCall = (url = '') => {
        allow.aString(url, is.not.empty);
        const currentInflightCalls = inflightCalls.get();
        currentInflightCalls.push(url);
        inflightCalls.set([...new Set(currentInflightCalls)]);
    };
   
    const isAlreadyInflight = (url = '') => {
        allow.aString(url, is.not.empty);
        const currentInflightCalls = inflightCalls.get();
        return currentInflightCalls.includes(url);
    };
   
    const removeApiCall = (url = '') => {
        allow.aString(url, is.not.empty);
        let currentInflightCalls = inflightCalls.get();
        currentInflightCalls = currentInflightCalls.filter(thisUrl => thisUrl !== url);
        inflightCalls.set([...new Set(currentInflightCalls)]);
    };
   
    return {
        addApiCall,
        isAlreadyInflight,
        removeApiCall,
    };
};